import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { api } from '../lib/api';

/* The Request button: ask for a feature or report a bug. It lands in the
   B/N Feedback group, where everyone can see it and add to it. */
export default function RequestDialog({ onClose, notify, onSent }) {
  const [kind, setKind] = useState('feature');
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  async function send() {
    setBusy(true);
    try {
      await api.sendFeedback(kind, text.trim());
      notify?.(kind === 'bug' ? 'Bug sent to B/N Feedback — thank you' : 'Request sent to B/N Feedback — thank you');
      onSent?.();
      onClose();
    } catch (e) {
      notify?.(e.message);
    } finally {
      setBusy(false);
    }
  }

  // On <body>, so it sits above the whole page, not inside the menu column.
  return createPortal(
    <div className="modal-back" role="presentation" onClick={onClose}>
      <div className="modal card pad req-dialog" role="dialog" aria-modal="true" aria-label="Send a request" onClick={(e) => e.stopPropagation()}>
        <div className="modal-top">
          <h2>What would make B/N better?</h2>
          <button className="linklike" aria-label="Close" onClick={onClose}>×</button>
        </div>
        <div className="seg" role="radiogroup" aria-label="Kind of request">
          {[['feature', 'Feature request'], ['bug', 'Something’s broken']].map(([k, l]) => (
            <button key={k} type="button" role="radio" aria-checked={kind === k}
              className={`seg-btn${kind === k ? ' on' : ''}`} onClick={() => setKind(k)}>{l}</button>
          ))}
        </div>
        <textarea className="ta" rows={5} autoFocus value={text} maxLength={2000} onChange={(e) => setText(e.target.value)}
          placeholder={kind === 'bug' ? 'What happened, and what did you expect?' : 'What should B/N do, and what would it help you with?'}
          onKeyDown={(e) => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey) && text.trim().length >= 3) { e.preventDefault(); send(); } }} />
        <p className="muted-sm">It goes to the <b>B/N Feedback</b> group under Groups, where every member can see it and add to it.</p>
        <div className="composer-actions">
          <button className="btn quiet sm" onClick={onClose}>Cancel</button>
          <button className="btn apply" disabled={busy || text.trim().length < 3} onClick={send}>{busy ? 'Sending…' : 'Send'}</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
